import React from 'react';
import './AboutUs.css'; // Create this CSS file for styling
import {useNavigate} from 'react-router-dom'
const AboutUs = () => {
  const navigate=useNavigate();
  return (
    <>
     <h2 className='banner2 text-normal'>About Our Palliative Care Initiative</h2>
    
        
        <p className="tagline text-center">Compassionate care for life's most challenging journeys</p>
     
       <div data-aos="fade-up" className="about-us-container">
                
      <section className="services-section">
        <h2>What We Do</h2>
        <div className="services-grid">
          <div className="service-card text-white">
            <h3 className='text-white'>Direct Care Services</h3>
            <p>Home-based palliative care tailored to individual needs and family circumstances</p>
          </div>
          <div className="service-card text-white">
            <h3 className='text-white'>Education & Training</h3>
            <p>Comprehensive courses for healthcare professionals, volunteers, and caregivers</p>
          </div>
          <div className="service-card text-white">
            <h3 className='text-white'>Community Empowerment</h3>
            <p>Supporting local initiatives to develop sustainable palliative care solutions</p>
          </div>
          <div className="service-card text-white">
            <h3 className='text-white'>Research & Advocacy</h3>
            <p>Advancing standards and policies for quality palliative care access for all</p>
          </div>
        </div>
      </section>

      <section className="values-section">
        <h2>Our Values</h2>
        <ul className="values-list">
          <li><strong>Compassion:</strong> Treating every individual with dignity and empathy</li>
          <li><strong>Community:</strong> Building local capacity for sustainable care</li>
          <li><strong>Excellence:</strong> Maintaining high standards through continuous learning</li>
          <li><strong>Equity:</strong> Ensuring access for marginalized and underserved populations</li>
          <li><strong>Collaboration:</strong> Partnering with communities to meet their unique needs</li>
        </ul>
      </section>
<div className='join-container'>
      <section className="join-section">
        
        <h2 className=''>Join Our Movement</h2>
        <p className='text-dark'>
          Whether you're a healthcare professional, volunteer, or community member, 
          you can help ensure no one faces a life-limiting illness alone. 
          Together, we can transform palliative care in our communities.
        </p>
        <button onClick={() => navigate('/volunteerform')} className="cta-button bg-info">Get Involved</button>
        
      </section>
      </div>
    </div>
     </>
  );
};

export default AboutUs;